export function Marquee({ items }) {
  const doubled = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-ink py-6 select-none" aria-hidden="true">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {doubled.map((it, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-display font-semibold uppercase text-[clamp(24px,3vw,38px)] tracking-tight text-white/80">
            {it}
            <span className="inline-block h-2 w-2 rotate-45 bg-amber" />
          </span>
        ))}
      </div>
    </div>
  );
}
